<template>
  <div id="regBindBook">
    <div class="app-top">
      <!-- <swiper-list :dataList="swiperList" :height="350" :interval="4000"></swiper-list> -->
    </div>
    <div class="center" id="regBindBook">
      <div class="container" v-loading="loading">
        <div style="max-width: 400px; margin:10px auto;padding: 40px 0 20px 0;">
          <el-form ref="form" :model="form" :rules="rules" :label-position=" isPc ? 'right' :'top'" label-width="100px" size="normal">
            <div v-if="isSuccess==false">
              <el-form-item>
                <!-- 标题 -->
                <div style="margin-bottom: 10px;text-align: center;">
                  <h2 style="font-size: 22px;font-weight: bold;color:#333">绑定手机号</h2>
                  <h3 style="font-size: 18px;font-weight: bold;color:#409EFF">{{ soft.name }}</h3>
                  <h3 style="margin-top: 10px;font-size: 16px;font-weight: normal;color:#666">
                    <div>即将停用“用户名”方式登录</div>
                    <div>请尽快绑定手机号码，以免无法使用</div>
                    <div>绑定后可使用“手机号+密码”方式登录</div>
                  </h3>
                </div>
              </el-form-item>
              <el-form-item prop="bookId" label="账本">
                <el-input v-model="form.bookName" maxlength="100" disabled style="color:#000"></el-input>
              </el-form-item>
              <el-form-item prop="userId" label="用户">
                <el-input v-model="form.userName" maxlength="20" disabled></el-input>
              </el-form-item>
              <el-form-item prop="mobile" label="绑定手机号">
                <el-input v-model="form.mobile" placeholder="将作为您的登录账号" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item prop="password" label="登录密码">
                <el-input v-model="form.password" placeholder="6-20位登录密码" maxlength="20" :type="passwordType">
                  <i
                    class="el-icon-view"
                    slot="suffix"
                    style="margin-right: 5px;"
                    @click="passwordType=passwordType=='password'?'text':'password'"
                  />
                </el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input v-model="form.code" style="width:50%" placeholder="短信验证码" type="text" />
                <el-button
                  style="width: calc(50% - 10px);margin-left: 10px;"
                  type
                  :disabled="!canSend"
                  :class="['code-side',!canSend ? 'code-side-default' : '']"
                  @click="getImage"
                >{{ codeName }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSubmit" style="width: 100%;">立即绑定</el-button>
                <div style="text-align: center;margin-top: 10px;">
                  <contact-service text="联系客服"></contact-service>
                </div>
              </el-form-item>
            </div>
            <el-form-item v-if="isSuccess">
              <div style="line-height: 26px;text-align: center;">
                <div style="color:green;">绑定成功！</div>
                <div style="color:green;margin: 20px 0;" v-if="resMessage">{{ resMessage }}</div>
                <div style="color:#000">下次可尝试使用“手机号+密码”方式登录</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <comm-desc />
    <verify-code-image-dialog ref="imgDialog" @confirm="sendCode" />
  </div>
</template>
  
<script>
import API from '@/api/_common.js'
import API_Product from '@/api/_product.js'
import API_Soft from '@/api/soft.js'
import commDesc from '@/components/commDesc'
import VerifyCodeImageDialog from '@/components/VerifyCodeImageDialog'
export default {
  name: 'TenantRegisterBindBook',
  components: {
    commDesc,
    VerifyCodeImageDialog
  },
  data() {
    return {
      loading: false,
      passwordType: 'password',
      resMessage: '',
      dataList: [],
      softList: [],
      form: {
        bookId: '',
        bookName: '',
        userId: '',
        userName: '',
        mobile: '',
        password: '',
        sign: '',

        productCode: '',
        productName: '',
        code: '',
        name: ''
      },
      codeName: '获取验证码',
      canSend: true,
      isSuccess: false,
      rules: {
        productCode: [{ required: true, message: '请选择产品', trigger: 'change' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'change' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'change' }]
      }
    }
  },
  watch: {},
  computed: {
    isPc() {
      return document.body.clientWidth > 800
    },
    soft() {
      let arr = this.softList.filter(m => m.licenseCode == this.form.productCode)
      if (arr.length != 1) {
        return {}
      } else {
        return arr[0]
      }
    }
  },
  mounted() {
    if (this.$route.query) {
      this.form.bookId = this.$route.query.bookId || ''
      this.form.bookName = this.$route.query.bookName || ''
      this.form.userId = this.$route.query.userId || ''
      this.form.userName = this.$route.query.userName || ''
      this.form.sign = this.$route.query.sign || ''

      this.form.productCode = this.$route.query.softLicenseCode || ''
      this.form.productName = this.$route.query.softName || ''
    }
    this.getSoftList()
  },
  created() {},
  methods: {
    //获取图片验证码
    getImage() {
      this.$refs.form.clearValidate(['code'])
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.canSend) {
            this.$refs.imgDialog.handleOpen()
          }
        }
      })
    },
    //发送短信
    sendCode(data) {
      this.$refs.form.clearValidate(['code'])
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.canSend) {
            API.verifyCodeSend({
              product: this.form.productCode,
              target: this.form.mobile,
              type: 'Register',
              imageKey: data.key,
              imageCode: data.code
            })
              .then(res => {
                console.log('已发送', res)
                //已发送,开始倒计时
                this.countDown(60, this)
                this.$refs.imgDialog.close()
              })
              .catch(err => {
                console.error(err)
                this.$refs.imgDialog.refreshImage()
              })
          }
        }
      })
    },
    //显示倒计时
    countDown(num, that) {
      var remainTime = num
      var cacheTime = new Date().getTime()
      var timer = setInterval(function () {
        var currTime = new Date().getTime()
        var vanishTime = Math.ceil(currTime - cacheTime) // 获得消失的时间
        var newRemainTime = parseInt(remainTime - vanishTime / 1000)
        if (newRemainTime >= 1) {
          that.codeName = `重新获取(${newRemainTime}s)`
          that.canSend = false
        } else {
          that.codeName = '获取验证码'
          that.canSend = true
          clearInterval(timer)
        }
      }, 1000)
    },
    handleSubmit() {
      this.$refs.form.validateField(['code'])
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.soft.licenseCode) {
            this.$message.error('无法识别的产品：' + this.form.productCode)
            return
          }
          this.loading = true
          API_Product.inviteToJoin(
            {
              product: this.form.productCode,
              bookId: this.form.bookId,
              bookName: this.form.bookName,
              userId: this.form.userId,
              userName: this.form.userName,
              mobile: this.form.mobile,
              password: this.form.password,
              code: this.form.code,
              sign: this.form.sign,
              // invite: this.common.inviteGet(),
              from: 'Web'
            },
            this.soft.apiUrl
            // 'http://localhost:53863/api2'
          ).then(res => {
            this.isSuccess = true
            this.resMessage = res.message
            this.loading = false
          })
        }
      })
    },
    getSoftList() {
      this.loading = true
      API_Soft.getList({}).then(res => {
        this.softList = res.data
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-top {
  margin-top: 58px;
}
</style>

<style lang="scss">
#regBindBook {
  @media screen and (max-width: 576px) {
    #regBindBook {
      .el-form-item {
        margin-bottom: 20px;
      }
      .el-form--label-top .el-form-item__label {
        line-height: 20px;
      }
      .el-form--label-top .el-form-item__label {
        padding: 0;
      }
    }
  }

  .el-input.is-disabled .el-input__inner {
    color: #333;
    background: #f8f8f8;
  }
}
</style>